import { render, staticRenderFns } from "./SaiAccordionPrimary.vue?vue&type=template&id=51ec1f3a"
import script from "./SaiAccordionPrimary.vue?vue&type=script&lang=js"
export * from "./SaiAccordionPrimary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports